export default __webpack_public_path__ + "static/media/app7-run.d9d40ffa.gif";